export const appointmentMachine = {
    name: 'appointment',
    states: ['booked', 'rescheduled', 'cancelled', 'attended', 'no_show'],
    labels: {
        booked: 'Gebucht',
        rescheduled: 'Verschoben',
        cancelled: 'Abgesagt',
        attended: 'Wahrgenommen',
        no_show: 'No-Show',
    },
    transitions: [
        {
            name: 'reschedule',
            label: 'Verschieben',
            from: ['booked'],
            to: 'rescheduled',
            fields: ['startsAt', 'endsAt'],
        },
        { name: 'cancel', label: 'Absagen', from: ['booked'], to: 'cancelled', fields: ['cancelledBy'] },
        { name: 'attended', label: 'Wahrgenommen', from: ['booked'], to: 'attended' },
        { name: 'no_show', label: 'No-Show', from: ['booked'], to: 'no_show' },
    ],
};
/** Booking rules (T1–T3): bookable from tomorrow for four weeks, rebooking until 2 h before, slot hold 10 min. */
export const bookingRules = {
    bookableFromDays: 1,
    bookableUntilDays: 28,
    rebookUntilHoursBefore: 2,
    slotHoldMinutes: 10,
};
//# sourceMappingURL=appointment.js.map